import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import WaveUIForm_V2 from '@/shared/components/forms/WaveUIForm_V2';
import FormField from '@/shared/components/forms/WaveUIForm_V2/types/formField.type';
import WaveUIAccordion from '@/shared/components/widgets/WaveUIAccordion';
import MetadataDefinitions from '@/shared/types/metadata/metadataDefinitions.type';

import MultiSelectMetadata from './components/MultiSelectMetadata';

type OptionalMetadataFormProps = {
  optionalMetadata: MetadataDefinitions[];
  optionalFormsList: FormField[][];
  handleFieldValuesChange: (
    fieldValue: Record<string, unknown>,
    index: number,
  ) => void;
  handleFieldVisibilityChange: (selectedMetadata: string[]) => void;
};

const OptionalMetadataForm: FC<OptionalMetadataFormProps> = ({
  optionalMetadata,
  optionalFormsList,
  handleFieldValuesChange,
  handleFieldVisibilityChange,
}) => {
  const { t } = useTranslation(['common']);

  const [selectedMetadata, setSelectedMetadata] = useState<string[]>([]);

  useEffect(() => {
    setSelectedMetadata(
      optionalFormsList
        .flat()
        .filter((item) => item.isVisible)
        .map((field) => field.field_props.name),
    );
  }, [optionalFormsList]);

  return (
    <WaveUIAccordion
      defaultExpanded={true}
      title={t('common:details')}
      elevation={1}
    >
      <MultiSelectMetadata
        selectedMetadata={selectedMetadata}
        optionalMetadata={optionalMetadata}
        onSelectMetadata={(selectedMetadataKeys) => {
          setSelectedMetadata(selectedMetadataKeys);
          handleFieldVisibilityChange(selectedMetadataKeys);
        }}
      />

      {optionalFormsList.map((form, idx) => {
        return (
          <WaveUIForm_V2
            key={idx}
            fields={form}
            getFieldsValues={(value) => handleFieldValuesChange(value, idx)}
          />
        );
      })}
    </WaveUIAccordion>
  );
};

export default OptionalMetadataForm;
